import { apiGet } from "../ApiMethod";
import { setDoor } from "../../mappers";
import { CheckValue } from "../../service";

export const getDoorsList = async (params = {}, cancelToken = null) => {
  const response = await apiGet("_doors", params, null, cancelToken);
  const doors = CheckValue(response.data?.doors) ? response.data.doors : [];
  return {
    ...response,
    rowData: doors.map(setDoor),
  };
};
